/*
  C - WLP Story Tabs (sections/c-wlp-story-tabs.liquid)
  - Tab buttons, the prev / next arrows and Left / Right keys on the tab row
    switch the visible pane.
  - Tabs after the next one get .is-later (faded label, as in Figma).
  - Videos in hidden panes are paused; the visible one plays.
  - Theme editor: selecting a tab block shows its pane.
*/
(() => {
  const initTabs = (root) => {
    if (root.dataset.wlpReady === 'true') return;
    root.dataset.wlpReady = 'true';

    const tabs = [...root.querySelectorAll('[data-stab-tab]')];
    const panes = [...root.querySelectorAll('[data-stab-pane]')];
    let current = 0;

    const show = (index, focus = false) => {
      if (index < 0 || index >= panes.length) return;
      current = index;
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('is-later', i > index + 1);
      });
      panes.forEach((pane, i) => {
        const active = i === index;
        if (active && pane.hidden) {
          pane.classList.remove('is-entering');
          void pane.offsetWidth;
          pane.classList.add('is-entering');
        }
        pane.hidden = !active;
        pane.querySelectorAll('video').forEach((video) => {
          if (active) {
            const play = video.play();
            if (play && play.catch) play.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
      if (focus) tabs[index].focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => show(i));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); show(Math.min(current + 1, tabs.length - 1), true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(Math.max(current - 1, 0), true); }
      });
    });
    root.querySelectorAll('[data-stab-prev]').forEach((button) => button.addEventListener('click', () => show(current - 1)));
    root.querySelectorAll('[data-stab-next]').forEach((button) => button.addEventListener('click', () => show(current + 1)));

    root.addEventListener('shopify:block:select', (event) => {
      const index = panes.indexOf(event.target.closest('[data-stab-pane]'));
      if (index >= 0) show(index);
    });

    show(0);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-wlp-stab]').forEach(initTabs);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
